import { Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

export default function CustomTooltip({ text, children, ...props }) {
    return (
        <Tooltip
            title={text}
            {...props}
            slotProps={{
                tooltip: {
                    sx: {
                        // whiteSpace: "pre-line",
                        backgroundColor: "#fff",
                        color: "#000000",
                        borderTop: "3px solid #013eb7",
                        fontSize: "14px",
                        padding: "8px 12px",
                        borderRadius: "8px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                        width: "max-content",
                        // maxWidth: 220,
                        mr: 1
                    },
                },
                arrow: {
                    sx: {
                        color: "#f5f5f5", // arrow background (same as tooltip)
                        "&::before": {
                            border: "1px solid #013eb7", // give the arrow a border
                            backgroundColor: "#f5f5f5",   // match tooltip bg
                            boxSizing: "border-box",
                        },
                    },
                },
            }}
        >
            {children || <InfoIcon sx={{ color: "#013eb7", cursor: "pointer", mr: 0.5 }} />}
        </Tooltip>
    );
}
